import React from "react";
import { styled } from "@mui/system";
import MUIButtonGroup from "@mui/material/ButtonGroup";
import {
  ButtonGroupProps as ButtonGroupPropsMUI,
  ButtonGroupTypeMap
} from "@mui/material/ButtonGroup";
import { OverridableComponent } from "@mui/material/OverridableComponent";

import { buttonGroupFic } from "./buttonGroupFicStyling";
import { buttonGroupVapor } from "./buttonGroupVaporStyling";

export interface ButtonGroupProps extends ButtonGroupPropsMUI {
  component?: React.ElementType;
}

const ButtonGroupRoot = styled(MUIButtonGroup, {
  name: "ButtonGroup",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) =>
  theme.name === "fic" ? buttonGroupFic(theme) : buttonGroupVapor(theme)
);

export const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  function ButtonGroup(props, ref) {
    return <ButtonGroupRoot disableRipple {...props} ref={ref} />;
  }
) as OverridableComponent<ButtonGroupTypeMap>;
